import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import * as $ from 'jquery';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>;

type State = {
    holidays: Holiday[];
    isLoading: boolean;

    name: string;
    date: Date | null;
};

type Holiday = {
    HolidayId: number;
    Name: string;
    Date: Date;
}

class Holidays extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            holidays: [],
            isLoading: false,

            name: '',
            date: null,
        }

        this.requestHolidays = this.requestHolidays.bind(this);
        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        this.requestHolidays();
    }

    
    public render() {
            
        return <React.Fragment>
            {this.state.isLoading && <LoadingPanel />}
            <DocumentTitle title="Holidays" />
            <div className="row">
                <div className="col">
                    <h1>Holidays</h1>
                </div>
                <div className="col">
                    <button type="button" className="btn btn-primary float-right" data-toggle="modal" data-target=".bd-example-modal-lg">Add Holiday</button>
                    <div id="holidayModal" className="modal fade bd-example-modal-lg" tabIndex={-1} role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Add Holiday</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Holiday Name"
                                            value={this.state.name}
                                            onChange={(e) => this.setState({ name: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <DatePicker
                                            format="MM/dd/yyyy"
                                            formatPlaceholder="formatPattern"
                                            value={this.state.date}
                                            onChange={(e) => this.setState({ date: e.value })}
                                        />
                                    </div>
                                    <button className="btn btn-success" onClick={this.save}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {(!this.state.isLoading && this.state.holidays.length === 0) &&
                <h3 className="text-center p-5">There is no Holiday. Go to add holiday for adding one</h3>
            }

            {(!this.state.isLoading && this.state.holidays.length != 0) && this.renderHolidaysTable()}
        </React.Fragment>;
    }

    private renderHolidaysTable() {


       return <table className='table'>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Date</th>
                    <th />
                </tr>
            </thead>
            <tbody> 
                {this.state.holidays.map((holiday, index) =>
                    <tr key={index}>
                        <td>{holiday.Name}</td>
                        <td>{moment.utc(holiday.Date).format("YYYY-MM-DD")}</td>
                        <td><button className="btn btn-danger float-right" onClick={(e) => {
                            e.preventDefault();
                            if (confirm(`Delete: ${holiday.Name}?`)) {
                                this.delete(holiday.HolidayId);
                            }
                        }}>Delete</button></td>
                    </tr>
                )}
            </tbody>
        </table>; 
    }

    private requestHolidays() {
        this.setState({ isLoading: true });
        fetchApi('/api/Holiday/List').then((data: Holiday[]) => {
            this.setState({ holidays: data, isLoading: false });
        });
    }

    private save() {

        if (!this.state.name) {
            alert("Please enter a holiday name!");
            return;
        }

        if (!this.state.date) {
            alert("Please enter a valid date!");
            return;
        }

        const data = {
            Name: this.state.name,
            Date: this.state.date
        }

        this.setState({ isLoading: true });
        fetchApi(`api/Holiday/Create`, data, 'POST')
            .then(() => {
                $("#holidayModal").modal('hide');
                this.requestHolidays();
                this.setState({ isLoading: false });
            });
    }

    private delete(holidayId: number) {
        this.setState({ isLoading: true });
        fetchApi(`api/Holiday/Delete/${holidayId}`, {}, 'DELETE')
            .then(() => {
                const holidays = this.state.holidays.filter(x => x.HolidayId !== holidayId).slice();
                this.setState({ holidays, isLoading: false });
            });
    }
}

export default Holidays;
